import { useContext } from 'react';
import * as R from 'ramda';

import ExpendituresChartContext from './ExpendituresChartContext';
import {
  BarIcon,
  getFixedBarColor,
  GroupKeys,
  LineIcon,
  RechartPayload,
} from './expendituresChartUtils';

const styles = {
  legendContainer: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
  },
  legendItemsColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  legendLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    fontWeight: 500,
  },
  legendSubLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1.5rem',
    marginBottom: '0.5rem',
  },
};

interface Props {
  payload?: RechartPayload[];
}

const ExpendituresChartLegend = ({ payload }: Props) => {
  const { futureFixedRemainingFields, data } = useContext(
    ExpendituresChartContext,
  );

  const entriesMap = R.groupBy(R.prop('dataKey'), payload);
  const getField = (field, val) => R.pathOr('', [field, 0, val], entriesMap);

  return !payload?.length ? null : (
    <div style={styles.legendContainer}>
      <div style={styles.legendItemsColumn}>
        {futureFixedRemainingFields.map((fieldName, idx) => (
          <div key={fieldName} style={styles.legendItem}>
            <span style={styles.legendLabel}>
              {fieldName.split(GroupKeys.FUTURE_FIXED_REMAINING)[0]}
            </span>
            <span style={styles.legendSubLabel}>
              {LineIcon(getField(fieldName, 'color'))} Remaining
            </span>
            <span style={styles.legendSubLabel}>
              {BarIcon(getField(fieldName, 'color'))} Actual Cost
            </span>
            {data.some(column => column[fieldName] > 0) && (
              <span style={styles.legendSubLabel}>
                {BarIcon(getFixedBarColor(idx))} Future Fixed Cost
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpendituresChartLegend;
